import { render, staticRenderFns } from "./changePassword-edit.vue?vue&type=template&id=71cd7ac6&scoped=true"
import script from "./changePassword-edit.vue?vue&type=script&lang=js"
export * from "./changePassword-edit.vue?vue&type=script&lang=js"
import style0 from "./changePassword-edit.vue?vue&type=style&index=0&id=71cd7ac6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cd7ac6",
  null
  
)

export default component.exports